import React from 'react';
import { DKVGrey } from '../constants';
import I18n from '../i18n';

const buttonStyle = {
  whiteButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  whiteButtonText: {
    textDecoration: 'underline',
    fontSize: '18px',
    color: DKVGrey
  }
};

const WhiteButton = ({ style, leftIcon, textKeys, rightIcon, onClick }) => (
  <span style={buttonStyle.whiteButtonWrapper} onClick={onClick}>
    {leftIcon}
    <span style={{ ...buttonStyle.whiteButtonText, ...style }}>
      <I18n keys={textKeys} />
    </span>
    {rightIcon}
  </span>
);

export default WhiteButton;